
<ng-container *ngIf="opened">
  <ng-content></ng-content>
</ng-container>
